<template>
  <div :key="applicationKey" id="app">
    <nav-bar v-if="token" />
    <aside-menu v-if="token && this.checkIfExistsAdmin()" :menu="menu" />
    <aside-menu v-if="token && this.checkIfExists()" :menu="menuSecond" />
    <aside-menu v-if="token && this.checkIfExistsAnalytics()" :menu="menuAnalytics" />
    <!-- <aside-menu v-if="token" :menu="menu" /> -->
    <router-view :key="$route.path" />
    <!-- <router-link to="/registration">Register</router-link> -->
    <!-- <router-link to="/registration"></router-link> -->

    <!-- <footer-bar v-if="token" /> -->

    <nav-bar v-if="token" />
    <!-- <footer-bar v-if="token" /> -->
  </div>
</template>

<script>
import NavBar from '@/components/NavBar';
import AsideMenu from '@/components/AsideMenu';
// import FooterBar from '@/components/FooterBar';
import { checkTokenValidity } from './helpers';

// const myTrack = new Audio(require('./assets/sound/sound.mp3'));

export default {
  data() {
    return {
      isLoginPage: false,
      token: localStorage.getItem('cafe_jwt'),
      role: '',
      applicationKey: 0,
      sortField: 'name',
      sortOrder: '+',
    };
  },
  components: { AsideMenu, NavBar },
  computed: {
    menu() {
        return [
          {
            to: '/',
            icon: 'desktop',
            label: 'Dashboard',
          },
          {
            to: '/profile',
            label: 'Profile',
            icon: 'user',
          },
        {
          to: '/managers',
          label: 'Managers',
          icon: 'tasks',
          updateMark: true,
          menu: [{ name: 'MIG' }],
        },
        {
          to: '/users',
          label: 'Shareholders',
          icon: 'users',
          updateMark: true,
          menu: [{ name: 'MIG' }],
        },
        {
          to: '/create',
          label: 'New Registration',
          icon: 'address-book'
        },
        {
          to: '/cards',
          label: 'Card Status',
          icon: 'id-card'
        },
      ];
    },
    menuSecond() {
        return [
          {
            to: '/',
            icon: 'desktop',
            label: 'Dashboard',
          },
          {
            to: '/profile',
            label: 'Profile',
            icon: 'user',
          },
        {
          to: '/users',
          label: 'Shareholders',
          icon: 'users',
          updateMark: true,
          menu: [{ name: 'MIG' }],
        },
        {
          to: '/create',
          label: 'New Registration',
          icon: 'address-book'
        },
        {
          to: '/cards',
          label: 'Card Status',
          icon: 'id-card'
        },
      ];
    },
    menuAnalytics() {
        return [
          {
            to: '/',
            icon: 'desktop',
            label: 'Dashboard',
          },
          {
            to: '/profile',
            label: 'Profile',
            icon: 'user',
          },
      ];
    },
    authUser() {
      return this.$store.state.isNavBarVisible;
    },
  },
  updated() {
    this.token = localStorage.getItem('cafe_jwt');
    this.role = localStorage.getItem('role');
  },
  created() {
    var currentUrl = window.location.pathname;

    if (currentUrl === '/login') {
      this.isLoginPage = true;
    }

    // console.log(this.isLoginPage);

    const authUser = this.$store.getters['auth/authUser'];

    const regex = /^\/resetPassword/;

    // debugger;

    if (regex.test(currentUrl)) {
      return;
    }

    if (!this.token || !checkTokenValidity(this.token)) {
      this.$router.push({ path: '/login' });
    }

    // this.$socket.on('newOrderAvailable', this.orderReceived);

    this.$store.commit('user', {
      name: 'Prabin Nepal',
      email: 'p.nepal404@gmail.com',
      avatar: '/data-sources/avatars/annie-spratt-121576-unsplash.jpg',
    });
  },
  methods: {
    checkIfExists(){
      if (typeof this.$store.state.auth.user == 'undefined' || this.$store.state.auth.user == null){
        return false;
      }
      else if (this.$store.state.auth.user.role == 2 || this.$store.state.auth.user.role == 3) {
        return true;
      } else {
        return false
      } 
    },
    checkIfExistsAnalytics(){
      if (typeof this.$store.state.auth.user == 'undefined' || this.$store.state.auth.user == null){
        return false;
      }
      else if (this.$store.state.auth.user.role == 4) {
        return true;
      } else {
        return false
      } 
    },
    checkIfExistsAdmin(){
      if (typeof this.$store.state.auth.user == 'undefined' || this.$store.state.auth.user == null){
        return false;
      }else if (this.$store.state.auth.user.role == 0 || this.$store.state.auth.user.role == 1) {
        return true;
      } else {
        return false
      } 
    }
    // orderReceived(orderObj) {
    //   const myTrack = new Audio(require('./assets/sound/sound.mp3'));
    //   myTrack.play();
    //   const prevNumber = this.$store.state.noOfUnreadNotifications;
    //   this.$store.dispatch('updateNumberOfNotification', prevNumber + 1);
    //   // this.$buefy.$snackbar-background-color  $light
    //   this.$buefy.snackbar.open({
    //     onAction: () => {
    //       this.$router.push({ path: `/orders/${orderObj._id}` });
    //     },
    //     actionText: 'View Order',
    //     type: 'is-primary',
    //     position: 'is-top-right',
    //     message: `<div>
    //                   <h2>New Order Received!</h2>
    //                   <h5>New Order was received from ${orderObj.user}</h5>
    //                   </div>`,
    //     queue: false,
    //   });
    //   const sortBy = this.sortOrder + this.sortField;
    //   this.$store
    //     .dispatch('orders/fetchOrders', {
    //       filter: {
    //         page: 1,
    //         limit: 10,
    //         sort: sortBy,
    //       },
    //     })
    //     .then(() => {});
    // },
  },
};
</script>


<style lang="scss">
//
</style>
